/**
 * @generated SignedSource<<bd9d52e74e5839c23dbdb019b4c379f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksHeaderOpinionArticle$data = {
  readonly entityUuid: string;
  readonly " $fragmentType": "hooksHeaderOpinionArticle";
};
export type hooksHeaderOpinionArticle$key = {
  readonly " $data"?: hooksHeaderOpinionArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksHeaderOpinionArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksHeaderOpinionArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a7c808667bded5c75077f1be6e6b0235";

export default node;
